module.exports = __webpack_public_path__ + "static/media/btc-flo.a489141e.png";